import { EU_COUNTRIES } from "../constants/Countries";

export const businessTypes = [
    { label: 'Corporation', value: 'corporation' },
    { label: 'Partnership', value: 'partnership' },
    { label: 'LLC', value: 'limited_liability_company' },
    { label: 'Sole Proprietorship', value: 'sole_proprietorship' },
    { label: 'Nonprofit', value: 'nonprofit'}
];

/*
    What each country calls the same legal structures. The labels change, the values we send
    don't, so a Ltd and a US corporation both go as corporation. Values stay unique within a
    list, because the select shows whichever option matches the value: two options sent as
    corporation would flip a PLC back to Ltd. Only the US has LLCs. Trusts (Australia) and
    LLPs (UK) have values of their own; the backend accepts them from streamlined/backend#1180.
*/
const BUSINESS_TYPES_BY_COUNTRY = {
    GB: [
        { label: 'Limited company (Ltd or PLC)', value: 'corporation' },
        { label: 'Limited liability partnership (LLP)', value: 'limited_liability_partnership' },
        { label: 'Partnership', value: 'partnership' },
        { label: 'Sole trader', value: 'sole_proprietorship' },
        { label: 'Charity or non-profit', value: 'nonprofit' },
    ],
    CA: [
        { label: 'Corporation (Inc. or Ltd.)', value: 'corporation' },
        { label: 'Partnership', value: 'partnership' },
        { label: 'Sole proprietorship', value: 'sole_proprietorship' },
        { label: 'Non-profit', value: 'nonprofit' },
    ],
    AU: [
        { label: 'Company (Pty Ltd)', value: 'corporation' },
        { label: 'Trust', value: 'trust' },
        { label: 'Partnership', value: 'partnership' },
        { label: 'Sole trader', value: 'sole_proprietorship' },
        { label: 'Not-for-profit', value: 'nonprofit' },
    ],
};

// Every EU country has its own names, so these are generic with examples.
const EU_BUSINESS_TYPES = [
    { label: 'Limited company (e.g. GmbH, SARL, BV, AG, SA)', value: 'corporation' },
    { label: 'Partnership', value: 'partnership' },
    { label: 'Sole trader', value: 'sole_proprietorship' },
    { label: 'Non-profit', value: 'nonprofit' },
];

export const businessTypesFor = (country) => {
    if (BUSINESS_TYPES_BY_COUNTRY[country]) return BUSINESS_TYPES_BY_COUNTRY[country];
    if (EU_COUNTRIES.includes(country)) return EU_BUSINESS_TYPES;
    return businessTypes;
};

export const getInvoiceStatus = (dueDate, balance) => {
    const invoice_balance = parseFloat(balance);
    if (invoice_balance <= 0) {
        return  invoice_balance === 0 ? 'Closed' : 'Has Credit';
    }

    const today = new Date(new Date().setHours(23, 59, 59, 999)).getTime();
    const due = new Date(new Date(dueDate).setHours(23, 59, 59, 999)).getTime();
    return due >= today ? 'Not yet due' : 'Overdue';
};
